import { useCallback } from "react";
import { mutate } from "swr";
import wretch from "wretch";
import QueryStringAddon from "wretch/addons/queryString";
import { msalConfig } from "../context/authContext";
import { FetcherOptions, PaginationQuery } from "../types";
import { authMiddleware } from "./middleware";

export type FileInfo = {
  data: string;
  contentType: string;
};

export const mutateCache = (keys: string[], skipKey?: string) => {
  for (const k of keys) {
    mutate(
      (key) => {
        if (typeof key === "string" && key !== skipKey) {
          return key === k || key.toLowerCase().startsWith(`${k}?`);
        }
        return false;
      },
      undefined,
      {
        revalidate: true,
      }
    );
  }
};

export const buildUrl = (url: string, query: PaginationQuery): string => {
  const params = new URLSearchParams();
  !!query.limit && params.set("limit", `${query.limit}`);
  !!query.page && params.set("page", `${query.page}`);
  !!query.q && params.set("q", query.q);
  // !!query.orderBy && params.set("order_by", query.orderBy);
  // query.desc != undefined && params.set("order", query.desc ? "desc" : "asc");
  // query.filters?.length && params.set("filters", JSON.stringify(query.filters));

  return url + (params.size > 0 ? `?${params.toString()}` : "");
};

export const useApi = () => {
  const w = wretch()
    .addon(QueryStringAddon)
    .middlewares([
      authMiddleware({
        scopes: [msalConfig.auth.clientId + "/.default"],
      }),
    ]);

  const api = w.url("/api");

  const get = useCallback(
    <Response>({ url, signal, headers }: FetcherOptions) =>
      api
        .options({ signal })
        .url(url)
        .headers(headers || {})
        .get()
        .json<Response>(),
    [api]
  );

  const post = useCallback(
    <Body, Response>(url: string, body?: Body) => api.url(url).post(body).json<Response>(),
    [api]
  );

  const postNoResult = useCallback(<Body>(url: string, body?: Body) => api.url(url).post(body).res(), [api]);

  const put = useCallback(<Body>(url: string, body: Body) => api.url(url).put(body).res(), [api]);

  const del = useCallback((url: string) => api.url(url).delete().res(), [api]);

  const mutateCache = (keys: string[], skipKey?: string) => {
    for (const k of keys) {
      mutate(
        (key) => {
          if (typeof key === "string" && key !== skipKey) {
            return key === k || key.toLowerCase().startsWith(`${k}?`);
          }
          return false;
        },
        undefined,
        {
          revalidate: true,
        }
      );
    }
  };

  return {
    get,
    post,
    postNoResult,
    put,
    del,
    mutateCache,
  };
};
